import { useStorage } from '@/utils/storage.js';
import { useMenuListStore } from '@/stores/index.js';
import { reactive } from 'vue'; 
import { forEach } from 'lodash';

const isJson = (str) => {
	try {
		JSON.parse(str);
		return true;
	} catch (e) {
		return false;
	}
}

//import Layout from '@/parts/layout/Index.vue';
const Layout = () => import('@/parts/layout/Index.vue');
//import Empty from '@/parts/layout/Empty.vue';
const Empty = () => import('@/parts/layout/Empty.vue');

// 取到 /views 目录下的所有的 .vue 页面文件
const views = import.meta.glob('/src/views/**/*.vue');

// 默认的路由
const defaultRoutes = reactive([{
	path: '/',
	name: '__home',
	meta: { title: '首页' },
	redirect: '/home',
	component: Layout,
	children: [{
		path: 'home',
		name: '__system-home',
		component: () => import('@/views/Home.vue'),  
		meta: {
			title: '控制面板'
		}
	}, {
		path: 'message',
		name: '__system-message',
		component: Empty,
		redirect: 'list',
		meta: { title: '系统消息' },
		children: [{
			path: 'list',
			name: '__system-message-list',
			component: () => import('@/views/message/List.vue'),
			meta: {
				title: '列表'
			}
		},
		{
			path: 'view-:id(\\d+)',
			name: '__system-message-view',
			component: () => import('@/views/message/View.vue'),
			meta: {
				title: '查看'
			} 
		}]
	}, {
		path: 'profile',
		name: '__system-profile',
		redirect: 'basic',
		component: () => import('@/views/system/Profile.vue'), 
		meta: {
			title: '个人中心'
		},
		children: [
			{
				path: 'basic', 
				name: '__system-profile-basic',
				component: () => import('@/views/system/profile/BasicInfo.vue'), 
				meta: {
					title: '基础资料'
				}
			},
			{
				path: 'changepwd', 
				name: '__system-profile-changepwd',
				component: () => import('@/views/system/profile/ChangePassword.vue'), 
				meta: {
					title: '修改密码'
				}
			}
		]
	}, {// 404 页面路由
		path: '/:pathMatch(.*)*', // 匹配所有路径
		name: '__system-page-not-found',
		meta: { title: '页面不存在' },
		component: () => import('@/parts/layout/NotFound.vue') // 404 页面组件
	}]
}, {
	path: '/login',
	name: '__login',
	component: () => import('@/views/Login.vue'),
	meta: {
		title: '登录'
	}
}]);

const generateRoutes = (menuList, parentName = '') => {
	return menuList.filter(item => {
		return item.type <= 1 // 筛选出菜单目录和菜单链接
	}).map(item => {
		const { name, url, default_url, path, query, type, title } = item
		const newName = parentName ? `${parentName}-${name}`:`${name}`
		const route = {
			name: newName, 
			path: url || '#',
			meta: { title }, 
			children: item.children ? generateRoutes(item.children, newName) : []
		}
		
		if(type == 0) {
			route['redirect'] = default_url
			route['component'] = Empty
		}
		else {
			const filePath = path.startsWith('/') ? path.substr(1) : path
			route['component'] = views[`/src/${filePath}`]
			
			if(query && isJson(query)) {
				route['props'] = JSON.parse(query)
			}
		}
		
		return route;
	})
}

export const useDynamicRoutes = () => {
	// 取第一个路由
	const homeRoute = defaultRoutes[0];
	
	const menuList = useStorage('local').get('menu_list') || [];
	if(menuList) {
		// defaultRoutes[0] 是路由表的第一个项（/）
		const routes = generateRoutes(menuList);
		forEach(routes, item => {
			const isExist = homeRoute.children.some(route => {
				return route.name == item.name
			})
			
			if(!isExist) {
				homeRoute.children.unshift(item)
			}
		})
	}
	
	return homeRoute
}

// 未登录时候，用默认路由
export const useAppRoutes = () =>{
	const routes = useDynamicRoutes();
	defaultRoutes[0] = routes;
	return defaultRoutes;
}
